<!-- 
  详情页 - 开票信息
  props:
    id: 详情id
 -->

<template>
	<div class="in-infos">
    <h3 class="title">发票信息</h3>
    <ul class="infos">
      <li>
        <label class="name">抬头类型：</label>
        <span class="text">{{invoice.titleTypeStr || '空'}}</span>
      </li>
      <li>
        <label class="name">发票抬头：</label>
        <span class="text">{{invoice.title || '空'}}</span>
      </li>
      <li>
        <label class="name">纳税识别号：</label>
        <span class="text">{{invoice.taxpayerNo || '空'}}</span>
      </li>
      <li>
        <label class="name">注册电话：</label>
        <span class="text">{{invoice.registeredPhone || '空'}}</span>
      </li>
      <li>
        <label class="name">开票地址：</label>
        <span class="text">{{invoice.invoiceAddress || '空'}}</span>
      </li>
      <li>
        <label class="name">开户行：</label>
        <span class="text">{{invoice.bank || '空'}}</span>
      </li>
      <li>
        <label class="name">开户账号：</label>
        <span class="text">{{invoice.account || '空'}}</span>
      </li>
    </ul>
    <a class="btn" @click="editInvoice">
      <i class="el-icon-setting"></i>
      <span class="text">编辑信息</span>
    </a>
    <h3 class="title">寄送地址</h3>
    <ul class="address">
      <li class="item" v-for="item in express">
        <div class="group">
          <label class="name">地址名称</label>
          <span class="text">{{item.name}}</span>
        </div>
        <div class="group">
          <label class="name">联系人</label>
          <span class="text">{{item.contact}}</span>
        </div>
        <div class="group">
          <label class="name">联系电话</label>
          <span class="text">{{item.phone}}</span>
        </div>
        <div class="group">
          <label class="name">详细地址</label>
          <span class="text">{{item.address}}</span>
        </div>
        <div class="group">
          <label class="name">邮政编码</label>
          <span class="text">{{item.zipCode}}</span>
        </div>
        <div class="options">
          <a class="link" v-if="!item.isDefault" @click="setDefault(item.id)">设为默认</a>
          <a class="link" @click="editExpress(item.id)">编辑</a>
          <a class="link red" @click="delHandle(item.id, item.name)">删除</a>
        </div>
        <div class="default" v-show="item.isDefault">
          默认
        </div>
      </li>
    </ul>
    <a class="btn" @click="editExpress()">
      <i class="el-icon-plus"></i>
      <span class="text">新建地址</span>
    </a>

    <add-new
      ref="addNew"
      v-if="addnewShow"
      :modal="false"
      :addnewProp="addnewProp"
      @refresh="getList"
      @closeForDetail="addnewShow=false">
    </add-new>
	</div>
</template>

<script>
import * as api from 'src/api'
import addNew from 'components/modal/add-new'
import { Message, MessageBox } from 'element-ui'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    moduleName: {
      type: String
    }
  },
  data () {
    return {
      invoice: {},
      express: [],
      addnewShow: false,
      addnewProp: {
        refId: this.id
      }
    }
  },
  methods: {
    handlePayStatus (bol) {
      this.getList()
    },
    getList () {
      let url = '/customerApi/getCustomerInvoiceExpressDetail.html'
      let params = {
        customerId: this.id
      }
      api.post(url, params, (data) => {
        this.invoice = data.customerInvoice
        this.express = data.customerExpress
      })
    },

    // 编辑发票信息
    editInvoice () {
      this.openAddNew(this.invoice.id, 'customerInvoice')
    },

    // 编辑配送信息
    editExpress (id) {
      this.openAddNew(id, 'customerExpress')
    },

    // 打开新建弹窗
    openAddNew (id, module) {
      this.addnewShow = false
      this.$nextTick(() => {
        this.addnewProp.module = module
        this.addnewProp.id = id
        this.addnewShow = true
      })
    },

    // 删除配送信息确认
    delHandle (id, name) {
      MessageBox.confirm(`是否删除“${name}”`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delExpress(id)
      }).catch(() => {})
    },

    // 删除配送信息
    delExpress (id) {
      let url = '/customerExpress/delete.html'
      let params = {
        id: id
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功!'
        })
        this.getList()
      })
    },

    // 设为默认地址
    setDefault (id) {
      let url = '/customerExpress/setDefault.html'
      let params = {
        id: id
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功!'
        })
        this.getList()
      })
    }
  },
  components: {
    addNew
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .in-infos {
    padding-left: 10px;
    .title {
      height: 24px;
      line-height: 24px;
      border-left: 4px solid @light-blue;
      color: @light-blue;
      padding-left: 12px;
      font-size: 15px;
      margin-bottom: 30px;
    }
    .btn {
      margin: 0 0 30px 20px;
      display: block;
      .text {
        font-size: 13px;
      }
    }
    .infos {
      line-height: 2;
      font-size: 13px;
      margin-left: 20px;
      margin-bottom: 20px;
      .name {
        color: @light-gray;
        display: inline-block;
        width: 92px;
      }
    }
    .address {
      padding-left: 20px;
      .item {
        position: relative;
        margin-bottom: 20px;
        border: 1px solid #dedede;
        border-radius: 2px;
        padding: 20px;
        background-color: #fff;
        .group {
          font-size: 13px;
          margin-bottom: 12px;
          .name {
            color: @light-gray;
            width: 92px;
            display: inline-block;
          }
        }
        .options {
          text-align: right;
          .link {
            margin-left: 10px;
            &.red {
              color: @bg-red;
            }
            &:hover {
              text-decoration: underline;
            }
          }
        }
        .default {
          position: absolute;
          right: 20px;
          top: 20px;
          font-size: 13px;
          &:after {
            position: absolute;
            left: -18px;
            top: -1px;
            content: "";
            width: 6px;
            height: 6px;
            border-radius: 10px;
            border: 4px solid @bg-orange;
          }
        }
      }
    }
  };

</style>


// WEBPACK FOOTER //
// invoice-detail.vue?709135c9